/**
 * Tiny module-level mirror of the current user's authenticated state.
 *
 * Auth is cookie/httpOnly based, so there is no JS-readable token in
 * localStorage/sessionStorage anymore (the legacy "BNPSERVICE" store is no
 * longer written on login). Code that lives outside React (e.g. utils/track)
 * needs a cheap, reliable "is the current user logged in?" signal, so the
 * AuthProvider keeps this module in sync whenever its auth status changes.
 */

let authenticated = false;

export function setClientAuthenticated(value: boolean): void {
  authenticated = value;
}

export function isClientAuthenticated(): boolean {
  return authenticated;
}
